// extracted by mini-css-extract-plugin
export var circle = "_1y-2";
export var icon = "_1y-a";
export var iconHighlight = "_1y-0";
export var lg = "_1y-8";
export var md = "_1y-7";
export var outline = "_1y-4";
export var sm = "_1y-6";
export var square = "_1y-1";
export var xl = "_1y-9";
export var xs = "_1y-5";
export var xxs = "_1y-3";